import React, { useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";

const Suspect = ({ onNext, onQuestion }) => {
    const [isPlaying, setIsPlaying] = useState(false); // State to track audio play status
  
    const audioRef = useRef(null);
  const handleContinue = () => {
    // Call the onNext function passed as a prop to move to the next step
    onNext(12);
    onQuestion(13)
    localStorage.setItem('support', JSON.stringify('support'));
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause(); // Pause the audio
        setIsPlaying(false);
      } else {
        audioRef.current.play(); // Play the audio
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false); // Reset to show Play button when audio ends
  };

  return (
    <div className="question">
      <div style={{ display: "flex",justifyContent:'center' }}>
        <div style={{ display: "flex",flexDirection:'column', alignItems: "center" }}>
        <div style={{ display: "flex" }}>
          <h2 htmlFor="lose-money">Fraudster’s Information</h2>
                    <button
                      onClick={toggleAudio}
                      className="audio_button"
                    >
                   {/* <FaPlay /> */}
                   {isPlaying ? <FaPause /> : <FaPlay />}
                    </button>
                    </div>
                    <audio ref={audioRef} onEnded={handleAudioEnd}>
                      <source src="audio\suspect.mp3" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>  
          <p className="suspect-para">Answer the set of questions about Fraudster/Suspect.</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button type="button" className="continue-btn" onClick={handleContinue}>
              Continue
            </button>
            {/* <p className="enter-text">
              press <strong>Enter ↵</strong>
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Suspect;
